import { faBars, faCubesStacked } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react';
import SearchAndModel from 'views/pages/dashboard/sales/search'
import { useSelector } from 'react-redux';
import { _Object } from 'utils/interfaces';

interface HeaderMobileProps {
  onSummaryOpen?: () => void;
}

const HeaderMobile = ({ onSummaryOpen }: HeaderMobileProps) => {
  const { cart } = useSelector((state: _Object) => state.cart);
  const totalItemCount = cart?.lineItems?.reduce(
    (acc: number, item: any) => acc + (Number(item?.quantity) || 1),
    0
  ) || 0;

  return (
    <>
      <header className="d-block d-md-none">
        <div className="mb-2">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <button
                type="button"
                className="nav-link border-0 bg-transparent d-flex flex-column align-items-center justify-content-center p-0"
                onClick={() => window.dispatchEvent(new CustomEvent('toggle-sidebar'))}
                aria-label="Toggle Navigation Sidebar"
              >
                <FontAwesomeIcon icon={faBars} size="lg" style={{ fontSize: '24px' }} />
              </button>
            </div>

            <div>
              <img src="/assets/images/logo.svg" alt="Cyfrid" height={100} width={100} className="img-fluid" />
            </div>

            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                className="p-0 border-0 bg-transparent"
                onClick={onSummaryOpen}
                data-bs-toggle="modal"
                data-bs-target="#todaySummaryModalMobile"
                aria-label="Summary"
              >
                <FontAwesomeIcon icon={faCubesStacked} className="me-0" style={{ fontSize: '24px' }} />
              </button>

              <button
                type="button"
                className="nav-link border-0 bg-transparent d-flex flex-column align-items-center justify-content-center p-0"
                data-bs-toggle="offcanvas"
                data-bs-target="#userSearch"
                aria-controls="userSearch"
                aria-label="Customer & Checkout"
              >
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" x="0" y="0" viewBox="0 0 512 512"><g><path d="M256 0c-74.439 0-135 60.561-135 135s60.561 135 135 135 135-60.561 135-135S330.439 0 256 0zm0 240c-57.897 0-105-47.103-105-105S198.103 30 256 30s105 47.103 105 105-47.103 105-105 105zM423.966 358.195C387.006 320.667 338.009 300 286 300h-60c-52.008 0-101.006 20.667-137.966 58.195C51.255 395.539 31 444.833 31 497c0 8.284 6.716 15 15 15h420c8.284 0 15-6.716 15-15 0-52.167-20.255-101.461-57.034-138.805zM61.66 482c7.515-85.086 78.351-152 164.34-152h60c85.989 0 156.825 66.914 164.34 152H61.66z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg>
              </button>

              <button
                type="button"
                className="position-relative border-0 bg-transparent p-0 d-flex align-items-center justify-content-center"
                data-bs-toggle="offcanvas"
                data-bs-target="#userSearch"
                aria-controls="userSearch"
                aria-label="View Cart"
              >
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="26" height="26" x="0" y="0" viewBox="0 0 24 24"><g><path d="M19.413 19H10.01a2.498 2.498 0 0 1-2.401-1.816L4.43 6.088A1.497 1.497 0 0 0 2.99 5H.5a.5.5 0 0 1 0-1h2.49c1.115 0 2.103.747 2.401 1.816L6.018 8h16.481c.479 0 .918.22 1.203.604.286.384.371.868.233 1.326l-2.151 7.35A2.496 2.496 0 0 1 19.413 19zM6.304 9l2.267 7.912c.179.642.77 1.088 1.439 1.088h9.403a1.51 1.51 0 0 0 1.416-1.018l2.149-7.338a.496.496 0 0 0-.078-.442.492.492 0 0 0-.401-.202zM11 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zM18 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg>
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                  {totalItemCount}
                </span>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-2">
          <SearchAndModel />
        </div>
      </header>
    </>
  )
}

export default HeaderMobile